
import { computed, defineComponent } from 'vue'
import IconSvg from '@/components/IconSvg.vue'
// Icons
import LogoIcon from '@/assets/images/logo.svg'
import WhiteLogoIcon from '@/assets/images/logo_white.svg'
import BGIcon from '@/assets/images/logo_square_white.svg'
import BGIconBlue from '@/assets/images/logo_square_blue.svg'
import PrimaryButton from '@/components/Buttons/PrimaryButton.vue'

export default defineComponent({
	name: 'EmptyTab',

	emits: ['to-products', 'close-tab'],

	components: {
		PrimaryButton,
		IconSvg
	},

	props: {
		customerNameToPrint: {
			type: String,
			default: ''
		},

		ticketNumber: {
			type: [String, Number],
			default: ''
		},

		allowGoToProducts: {
			type: Boolean,
			default: true
		},

		darkTheme: {
			type: Boolean,
			default: false
		}
	},

	setup(_, { emit }) {
		// Computed
		const logoIcon = computed(() => LogoIcon)
		const whiteLogoIcon = computed(() => WhiteLogoIcon)
		const bGIcon = computed(() => BGIcon)
		const bGIconBlue = computed(() => BGIconBlue)

		// Methods
		const toProducts = () => emit('to-products')

		const closeTab = () => emit('close-tab')

		return {
			logoIcon,
			whiteLogoIcon,
			bGIcon,
			bGIconBlue,
			toProducts,
			closeTab
		}
	}
})
